import {
  FetchLifestyleCategoriesCacheKey,
  FetchFinLifestyleCategoriesFilters
} from '../../lifestylesTypes';

import {
  FetchLifestyleTypesQueryResponse,
  FETCH_LIFESTYLE_TYPES_QUERY
} from '../../queries/fetchLifestyleTypes.query';

import { useFinPaginatedCategories } from '../../../categories/hooks/useFinPaginatedCategories';

import { FetchCategoriesScopes } from '../../../categories/categoriesTypes';
import { CACHE_FETCH_LIFESTYLE_TYPES_QUERY } from '../../queries/fetchCacheLifestyleTypes.query';
import { CategoriesPermissions } from '../../../categories/categoriesConstants';

const defaultInitialFilters = {
  scope: { eq: FetchCategoriesScopes.LIFESTYLES_TYPES }
};
const options = {
  staleTime: 1000 * 60 * 60
};

interface LifestyleTypesDefaultOptions {
  cacheKey: FetchLifestyleCategoriesCacheKey;
  addInitialFilters?: FetchFinLifestyleCategoriesFilters;
}

function useLifestyleTypes({
  cacheKey,
  addInitialFilters
}: LifestyleTypesDefaultOptions) {
  const initialFilters = addInitialFilters
    ? { ...defaultInitialFilters, ...addInitialFilters }
    : defaultInitialFilters;

  const {
    categories,
    categoriesError,
    categoriesFetched,
    categoriesIsPlaceholderData
  } = useFinPaginatedCategories<FetchLifestyleTypesQueryResponse>({
    action: CategoriesPermissions.READ_LIFESTYLE_CATEGORIES_INDEX_ES_QUERY,
    cacheKey,
    query: FETCH_LIFESTYLE_TYPES_QUERY,
    cacheQuery: CACHE_FETCH_LIFESTYLE_TYPES_QUERY,
    initialFilters,
    options
  });

  return {
    lifestyleTypes: categories,
    lifestyleTypesErrorMessage: categoriesError,
    lifestyleTypesFetched: categoriesFetched,
    lifestyleTypesIsPlaceholderData: categoriesIsPlaceholderData
  };
}

export default useLifestyleTypes;
